import axios from "axios";
import Cookies from "universal-cookie";
const apiUrl = "http://localhost:5260";
const cookies = new Cookies();

export const addTaxonomyApi = async (
  url: string,
  type: string,
  code: number,
  value: string,
  hiddenforUser: boolean
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/taxonomy/add`,
      {
        Type: type,
        Code: code,
        Value: value,
        IsHiddenForUser: hiddenforUser
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
};

export const fetchTaxonomiessApi = async (url: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${url}/taxonomy/gettaxonomy`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const deleteTaxonomyApi = async (url: string, id: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.request({
      method: "DELETE",
      url: `${url}/taxonomy/delete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting taxonomy:", error);
    throw error;
  }
};

export const fetchTaxonomyByIdApi = async (url: string, taxonomyId: string) => {
  const cookies = new Cookies();
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(
      `${url}/taxonomy/gettaxonomybyid/${taxonomyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching user by ID:", error);
    return false;
  }
};

export const updateTaxonomyApi = async (
  url: string,
  id: string,
  type: string,
  code: number,
  value: string,
  hiddenforUser?: boolean
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/taxonomy/updatetaxonomy`,
      {
        Id: id,
        Type: type,
        Code: code,
        Value: value,
        IsHiddenForUser: hiddenforUser

      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addMultipleTaxonomiesApi = async (
  url: string,
  taxonomies: { type: string; code: number; value: string }[]
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/taxonomy/addmultipletaxonomies`,
      taxonomies,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error: any) {
    console.error(
      "Error adding multiple taxonomies:",
      error.response?.data || error
    );
    throw error;
  }
};

export const isMultipleApi = async (url: string, type: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(
      `${url}/taxonomy/IsTaxonomyMultipleByType/${type}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error checking if taxonomy is multiple:", error);
    throw error;
  }
};

export const addSubTypeApi = async (
  url: string,
  parentid: string,
  type: string,
  code: number,
  value: string
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/taxonomy/addsubtype`,
      {
        ParentId: parentid,
        Type: type,
        Code: code,
        Value: value,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
